import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'dating_mood'

export default function DatingMoodPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const formAnswer = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: "What's your current mood around dating?",
      answer_key: formAnswer.toLowerCase(),
      answer: formAnswer,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.datingMood.heading')}
      buttons={[
        {
          text: `😌 ${t('pages.onboarding.datingMood.options.hopeful')}`,
          value: 'hopeful',
        },
        {
          text: `😩 ${t('pages.onboarding.datingMood.options.frustrated')}`,
          value: 'frustrated',
        },
        {
          text: `🧠 ${t('pages.onboarding.datingMood.options.curious')}`,
          value: 'curious',
        },
        {
          text: `😎 ${t('pages.onboarding.datingMood.options.confident')}`,
          value: 'confident',
        },
        {
          text: `😶 ${t('pages.onboarding.datingMood.options.indifferent')}`,
          value: 'indifferent',
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
    />
  )
}
